import axios from "axios";
import config from "../../config";

export default function ResumeCheckerService() {
    return {
        async postResumeChecker(formData: FormData | { job_title: string; job_description: string; resume_key: string }) {
            const baseUrl = config.functions.base_url;
            if (!baseUrl) {
                return Promise.reject(new Error("REACT_APP_ONE_PROFILE_FUNCTIONS_URL is not configured"));
            }

            // Check if formData is FormData or plain object
            const isFormData = formData instanceof FormData;
            
            if (isFormData) {
                // If it's FormData (has file), use multipart/form-data
                return axios.post(
                    `${baseUrl}/api/ai/resume-checker`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                ).then(res => res).catch(err => Promise.reject(err));
            } else {
                // If it's plain object (no file), use JSON
                return axios.post(
                    `${baseUrl}/api/ai/resume-checker`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                ).then(res => res).catch(err => Promise.reject(err));
            }
        }
    };
}

